import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Stack,
} from '@mui/material';
import { 
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  SearchOff as SearchOffIcon,
} from '@mui/icons-material';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box 
      sx={{ 
        py: { xs: 8, md: 12 }, 
        backgroundColor: 'background.default',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="md">
        <Paper sx={{ p: { xs: 4, md: 8 }, textAlign: 'center' }}>
          <SearchOffIcon 
            sx={{ 
              fontSize: { xs: 80, md: 120 }, 
              color: 'primary.main',
              mb: 3,
              opacity: 0.8,
            }} 
          />
          
          <Typography 
            variant="h1" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontSize: { xs: '3rem', md: '4rem' },
              fontWeight: 700,
              color: 'text.primary',
            }}
          >
            404
          </Typography>
          
          <Typography 
            variant="h4" 
            component="h2" 
            gutterBottom
            sx={{ 
              fontSize: { xs: '1.5rem', md: '2rem' },
              mb: 2,
            }}
          >
            Page Not Found
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            paragraph
            sx={{ 
              mb: 4,
              fontSize: { xs: '1rem', md: '1.1rem' },
            }}
          >
            The page you're looking for doesn't exist or has been moved. 
            Let's get you back on track.
          </Typography>
          
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{ px: 4 }}
            >
              Go to Homepage
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{ px: 4 }}
            >
              Go Back
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;
